export default "__VITE_ASSET__DW745trt__"